// PromptGenerator/components/DeleteAllModal.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import styles from '../PromptLayout.module.css';

interface DeleteAllModalProps {
  isOpen: boolean;
  onClose: () => void;
  promptsCount: number;
  onConfirm: () => Promise<void>;
  isDeleting: boolean;
}

export const DeleteAllModal: React.FC<DeleteAllModalProps> = ({
  isOpen, onClose, promptsCount, onConfirm, isDeleting
}) => {
  const { t } = useTranslation('promptGenerator');
  
  if (!isOpen) return null;

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>{t('promptGenerator.deleteModal.title')}</h3>
          <button className={styles.closeButton} onClick={onClose} disabled={isDeleting}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className={styles.modalBody}>
          <p>
            {t('promptGenerator.deleteModal.message', { count: promptsCount })}
          </p>
          <p className={styles.warningText}>
            {t('promptGenerator.deleteModal.warning')}
          </p>
        </div>
        <div className={styles.modalActions}>
          <button
            className={styles.cancelButton}
            onClick={onClose}
            disabled={isDeleting}
          >
            {t('promptGenerator.promptLayout.cancel')}
          </button>
          <button
            className={styles.deleteButton}
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <FontAwesomeIcon icon={faSpinner} className={styles.spinning} />
                {t('promptGenerator.deleteModal.deleting')}
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faTrash} />
                {t('promptGenerator.deleteModal.confirm')}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAllModal;
